import Request, { API } from '@/http/'
import { formatAmount } from '@/utils/convert'
import request from '@/http/axios'

// 客服信息
export async function customerServiceInfo () {
  const res = await Request.getData(API.user.customerServiceInfo)
  return res.data
}

// 问题反馈下拉框数据
export async function getColumns (type) {
  const res = await Request.getData(`${API.user.getColumns}/${type}`)
  if (type === 'IDCARD_TYPE') {
    return res
  } else {
    return res.data.dictList.map(item => ({ value: item.typeName, label: item.remark || item.typeName }))
  }
}

// 问题反馈
export async function complaint (data) {
  const res = await Request.getData(API.user.complaint, data)
  return res
}

// 登出
export async function logout () {
  const res = await Request.getData(API.user.logout)
  return res
}

// 用户基本信息
export async function baseInfo () {
  const res = await Request.getData(API.user.baseInfo)
  return res
}

// 检查用户放款状态
export async function checkLoanStatus () {
  const res = await Request.getData(API.user.checkLoanStatus)
  return res
}

// 额度信息
export async function creditInfo () {
  const res = await Request.getData(API.user.creditInfo)
  res.data.totalLabel = formatAmount(res.data.total)
  res.data.unusedLabel = formatAmount(res.data.unused)
  res.data.lockingLabel = formatAmount(res.data.locking)
  res.data.usedLabel = formatAmount(res.data.used)
  return res
}

// 待还订单
export async function repayOrderBase () {
  const res = await Request.getData(API.user.repayOrderBase)
  res.data.orderRecordList.forEach(item => {
    item.amountLabel = formatAmount(item.amount)
  })
  return res
}

// 银行卡列表
export async function bankCardList () {
  const res = await Request.getData(API.user.bankCardList)
  return res
}

// 修改银行卡认证步骤
export async function getModifySteps () {
  const res = await Request.getData(API.user.getModifySteps)
  return res
}

// 银行列表
export async function bankList (type) {
  const res = await Request.getData(`${API.user.bankList}?type=${type}`)
  return res.data.banks.map(item => ({ value: item.bankCode, label: item.bankName }))
}

// 修改银行卡
export async function changeCard (data) {
  const res = await Request.getData(API.user.changeCard, data)
  return res
}

// 修改银行卡人脸对比
export function faceCheck (data) {
  const formDate = new FormData()
  const file = new File([data.photo], 'photo.png')
  formDate.append('photo', file)

  return request({
    url: '/api/auth/modify-bankcard-face-check',
    method: 'POST',
    data: formDate,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}
